import { ALIGN_CLASSES_INVERSE as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { stylable as r } from "../decorators/stylable.js";
import "../decorators.js";
var i = r(n({
	inline: !1,
	content: "inline*",
	group: "block",
	attrs: t({ type: { default: "small" } }),
	parseDOM: [{
		tag: "small",
		getAttrs(t) {
			let n;
			return t.parentElement && t.parentElement.classList.forEach((t) => {
				let r = e[t];
				r && (n = r);
			}), { alignment: n };
		}
	}],
	toDOM() {
		return ["small", 0];
	}
}));
//#endregion
export { i as smallSpec };
